import LectureContent from "@/features/web/lecture/LectureContent";
import { Outlet } from "react-router-dom";
import MetaTags from "../../components/MetaTags";

function Lecture() {
    return (
        <div className="min-h-screen bg-background-color">
            <MetaTags
                title="مستر شريف أسامة | محتويات المحاضره"
                description="صفحة محتويات المحاضره على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض محتويات المحاضره لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <LectureContent>
                <Outlet />
            </LectureContent>
            <div className="relative py-20 top-40 bg-background-color"></div>
        </div>
    );
}

export default Lecture;
